// Copyright © 2021 Move Closer
import { computed } from '@vue/composition-api';
import { canBeDisabledProp } from '../../_composables';
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export const abstractLinkProps = {
    ...canBeDisabledProp,
    /**
     * The link to render.
     */
    link: {
        type: Object,
        required: true
    }
};
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export const useLink = (props) => {
    /**
     * Value for the `[target]` attribute of the `<a>` element.
     */
    const aTarget = computed(() => {
        return props.link.newTab ? '_blank' : '_self';
    });
    /**
     * Determines whether the passed-in `link` prop has a valid `target` property.
     */
    const hasCorrectTarget = computed(() => {
        const target = props.link.target;
        if (typeof target === 'undefined') {
            return false;
        }
        if (typeof target === 'object' && target === null) {
            return false;
        }
        // noinspection RedundantIfStatementJS
        if (typeof target === 'string' && target.length === 0) {
            return false;
        }
        return true;
    });
    const external = computed(() => {
        const target = props.link.target;
        const toCheck = typeof target !== 'string' ? `${target.path}` : target;
        return props.link.isExternal || toCheck.toLowerCase().startsWith('http://') || toCheck.toLowerCase().startsWith('https://');
    });
    const rel = computed(() => {
        const rels = new Set();
        if (props.link.nofollow)
            rels.add('nofollow');
        if (props.link.sponsored)
            rels.add('sponsored');
        if (props.link.rel)
            props.link.rel.split(' ').forEach(rel => rels.add(rel));
        return Array.from(rels).join(' ') || undefined;
    });
    return {
        aTarget,
        hasCorrectTarget,
        external,
        rel,
        label: computed(() => props.link.label),
        target: computed(() => props.link.target)
    };
};
